<template>
  <div class="opc-delta-edit-container">
    <h3 class="opc-zm-base-card__main__sub__title">{{ $t('billing.delta.buy_more_licenses') }}</h3>
    <bought-license :type="planType" showExtraInfo :extraInfo="$t('billing.delta.get_more_licenses')" />
    <div class="opc-zm-base-card__main__content">
      <InputNumberWithPopover
        v-model="deltaForm.selectedNumber"
        class="opc-quantity-selector"
        size="large"
        controls-position="both"
        :min="1"
        :max="99"
        :label="`${trackingPlanName} Select the number of license(s)`" />
      <span class="opc-modal-tips-title">
        {{ $t('billing.delta.new_licenses') }}
      </span>
      <span class="opc-modal-billing-cycle">
        <inline-price :price="currentBillingCyclePrice.price"></inline-price>
        <span class="opc-modal-cycle-info">
          {{ currentBillingCyclePrice.unit }},
          {{ getBillTextByCycle(currentEditPlan.billing_cycle) }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { get, throttle } from 'lodash';
import { getPlanUnitWithCycle, planUnitMap } from '@/common/product-unit';
import { trackingPlanTypes, planTypes } from '@/common/constants';
import { getBillTextByCycle } from '@/common/product-unit';


import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import InlinePrice from '@/components/inline-price.vue';
import BoughtLicense from '@/views/config/shopping-cart/prorated/bought-license.vue';

export default {
  name: 'DeltaEditMian',
  data() {
    return {
      deltaForm: {
        selectedNumber: 1,
      },
    };
  },
  props: {
    planType: {
      type: String,
      require: true,
    },
    title: {
      type: String,
      require: true,
    }
  },
  components: {
    BoughtLicense,
    InputNumberWithPopover,
    InlinePrice,
  },
  mounted() {
    const currentBoughtPlanSelectedNumber = this.currentBoughtPlan?.cartInfo?.selected_number || 1;
    const currentSelectedPlan = this.getSelectedPlans.find(p => p.type === this.planType);
    const currentSelectedPlanSelectedNumber = currentSelectedPlan?.cartInfo?.selected_number;
    const addQty = currentSelectedPlanSelectedNumber - currentBoughtPlanSelectedNumber;
    this.deltaForm.selectedNumber = Number(addQty) > 0 ? Number(addQty) : 1;
  },
  computed: {
    ...mapGetters(['boughtPlans', 'currentEditPlan', 'getSelectedPlans']),
    currentBoughtPlan() {
      return this.boughtPlans?.find((item) => item.plan_code === this.currentEditPlan.plan_code) || {};
    },
    trackingPlanKey() {
      return get(trackingPlanTypes, get(planTypes, this.planType));
    },
    trackingPlanName() {
      if (this.planType === planTypes.LARGE_MEETING) {
        return `${this.trackingPlanKey} ${this.currentEditPlan.capacity} participants`;
      }
      return `${this.trackingPlanKey} `;
    },
    currentBillingCyclePrice() {
      const unit = planUnitMap.license;

      return {
        price: (this.currentEditPlan.amount / 100).toFixed(2),
        unit: getPlanUnitWithCycle(this.currentEditPlan.billing_cycle, unit),
      };
    },
  },
  watch: {
    'deltaForm.selectedNumber': {
      handler() {
        this.$nextTick(() => {
          const selectedNumber =
            (this.currentBoughtPlan?.cartInfo?.selected_number ?? 0) + this.deltaForm.selectedNumber;
          this.submitForm(selectedNumber);
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    submitForm: throttle(function (v) {
      this.$nextTick(() => {
        this.updateSelectPlan({
          plan_code: this.currentEditPlan.plan_code,
          cartInfo: { selected_number: v },
        });
      });
    }, 200),
    getBillTextByCycle(billingCycle) {
      return getBillTextByCycle(billingCycle);
    },
  }
}
</script>

<style lang="scss" scoped>
.opc-delta-edit-container {
  .opc-zm-base-card__main {
    &__sub__title {
      color: #00031F;
      font-size: 18px;
      font-weight: 700;
      line-height: 150%;
      margin-bottom: 4px;
    }

    &__content {
      display: flex;
      margin-top: 12px;
      align-items: baseline;
      // .opc-quantity-selector {

      // }
      .opc-modal-tips-title {
        font-size: 16px;
        font-weight: 600;
        margin: 0 8px;
        flex-shrink: 0;
      }
      .opc-modal-billing-cycle {
        margin-left: 12px;
        display: inline-flex;
        flex-wrap: nowrap;
        gap: 8px;
        .opc-modal-cycle-info {
          color: #6e7680;
        }
      }
    }
  }
}
</style>
